import {
  Client,
  clientAddressStatus,
  clientReportStatus,
  clientReturnStatus,
  clientSpecieOptions,
  clientStatus,
} from "@domain/models/Client";
import { Timestamp } from "firebase/firestore";

export const defaultImportClient: Client = {
  id: "",
  cpf: "",
  name: "",
  email: "",
  motherName: "",

  age: "",
  birthDate: "",

  cityMap: "",
  mapId: "",
  lat: null,
  lng: null,

  isSelected: false,
  status: clientStatus.OPEN,
  specie: clientSpecieOptions.DISABILITY,
  specialIcon: false,

  validAddress: "S1",
  addressStatus: clientAddressStatus.FOUND,
  addresses: {
    S1: {
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      state: "",
      zipCode: "",
    },
    S2: {
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      state: "",
      zipCode: "",
    },
    O1: {
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      state: "",
      zipCode: "",
    },
    O2: {
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      state: "",
      zipCode: "",
    },
  },

  phones: {
    "0": "",
    "1": "",
    "2": "",
    phone: "",
  },
  telephone: {
    "0": "",
    "1": "",
    "2": "",
    primary: "",
    secondary: "",
  },

  processes: "",
  analysis: "",
  rejection: {
    date: "",
    reason: "",
    nb: "",
    derDate: "",
  },

  hasReturn: false,
  returnStatus: clientReturnStatus.NO_RETURN,
  returnExpireDate: "",

  operatorId: "",
  operatorName: "",

  reportStatus: clientReportStatus.NOT_ATTEND,
  lastReportId: "",
  lastReportResult: "",
  lastReportDescription: "",
  lastReportDate: "",
  currentRouteId: "",

  createdAt: Timestamp.now(),
  updatedAt: Timestamp.now(),
};
